<template>
  <b-overlay 
    :show="busy" 
    variant="dark"
  >
    <b-card 
      v-for="(kpi) in types" 
      :key="kpi"
      no-body
    >
      <b-card-header v-if="kpis[kpi] !== null">
        <b-card-title>{{ getTitle(kpi) }}</b-card-title>
        <b-card-sub-title v-if="kpis[kpi] !== null">
          {{ kpis[kpi].installateur.naam }}
        </b-card-sub-title>
      </b-card-header>
      <b-card-body>
        <kpi-afspraak 
          v-if="kpis[kpi] !== null" 
          v-model="kpis[kpi]" 
          :type="kpi"
        />
        <b-button 
          v-else
          variant="secondary" 
          @click="() => createKpi(kpi)"
        >
          {{ getTitle(kpi) }} <font-awesome-icon 
            icon="arrow-down" 
          />
        </b-button>
      </b-card-body>
      <b-card-footer v-if="kpis[kpi] !== null">
        <b-button 
          variant="ghost-danger" 
          class="pull-right" 
          @click="() => deleteKpi(kpi)"
        >
          <font-awesome-icon icon="trash" /> Verwijderen
        </b-button>
        <b-button 
          variant="success" 
          @click="() => updateKpi(kpi)"
        >
          <font-awesome-icon icon="save" /> Opslaan
        </b-button>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>
<script>
import { serviceMixin } from '@/mixins/serviceMixin.js'

export default {
    name: 'TabKpi',
    components: {
      KpiAfspraak: () => import('@/components/KpiAfspraak.vue')
    },
    mixins: [ serviceMixin ],
    beforeRouteUpdate (to, from, next) {
        if (to.params.id != from.params.id) this.getKpis(to.params.id);
        next();
    },
    props: {
        unit: {
            type: Object,
            default: null
        }
    },
    data() {
        return  {
            busy: false,
            types: ['standaardAfspraak', 'relatieAfspraken', 'complexAfspraken', 'unitAfspraak'],
            kpis: {
                standaardAfspraak: null,
                relatieAfspraken: null,
                complexAfspraken: null,
                unitAfspraak: null
            }
        }
    },
    computed: {
        url: function() {
            return "/unit/" + this.$route.params.id  + '/kpi';
        },
    },
    watch: {},
    mounted () {
        this.getKpis(this.$route.params.id);
    },
    methods: {
        createKpi(act) {
            // console.log(act.toLowerCase());
            this.post(this.getTitle(act.toLowerCase())).then(
                (response) => {
                    
                    this.kpis[act] = response.data['kpi-afspraak'];
                });
            // console.log(this.getTitle(act));
        },  
        updateKpi(act) {
            this.post(this.getTitle(act.toLowerCase()), { data: this.kpis[act] }).then(
                (response) => {
                    console.log(response.data);
                    this.kpis[act] = response.data['kpi-afspraak'];
                });
        },
        deleteKpi(act) {
            this.delete(this.getTitle(act.toLowerCase())).then(
                (response) => {
                    console.log(response.data);
                    this.kpis[act] = null;
                });
        },  
        getTitle(cat) {
            return this.url + "/" + cat;
        },
        getKpis(id) {
            this.busy = true;
            console.log(id);
            this.get("/unit/" + id  + "/kpi").then(
                (response) => {
                    this.kpis = response.data;
                }).finally(() => {
                    this.busy = false;
                })
        }
    },
          
}
</script>